import { render, staticRenderFns } from "./MailingAddress.vue?vue&type=template&id=708692a6&scoped=true"
import script from "./MailingAddress.vue?vue&type=script&lang=js"
export * from "./MailingAddress.vue?vue&type=script&lang=js"
import style0 from "./MailingAddress.vue?vue&type=style&index=0&id=708692a6&prod&lang=scss&scoped=true"
import style1 from "./MailingAddress.vue?vue&type=style&index=1&id=708692a6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708692a6",
  null
  
)

export default component.exports